import { initAdjustWeb } from '@/init/adjustWeb'
import { initMixpanel } from '@/init/mixpanel'
import { sentryInit } from '@/init/sentry-init'

const { testimonials } = require('@/assets.v2/js/pagesSite.js')
const { header } = require('@/assets.v2/js/header.js')
const { productsPilotForm } = require('@/assets.v2/js/productsPilotForm.js')

import { AdjustWrapper } from '@/analytics/adjust'
import { Mixpanel } from '@/analytics/mixpanel'
import { initAB } from '@/services/ab'
import { assertNotNull } from '@/helpers/typing'
import { setLocation } from '@/helpers/routes'
import { applyNavbarButtons } from '@/pages-site-v2/helpers/navbar'

export function initPageSiteV2(): void {
  initMixpanel()
  sentryInit()
  initAdjustWeb()

  document.addEventListener('DOMContentLoaded', function () {
    header()
    testimonials()
  })
}

export async function onPageLoad(): Promise<void> {
  initAB()
  Mixpanel.pageView()
  if (window.location.pathname === '/') {
    await AdjustWrapper.trackPageViewHomepage()
  }

  trackCTAClicks()
  setupEmailForm()
  applyNavbarButtons()

  if (window.location.pathname.startsWith('/pilot/')) {
    productsPilotForm()
  }
}

export function setupEmailForm(): void {
  const form = document.querySelector('.get-free-summary__form')
  if (form) {
    form.addEventListener('submit', handleEmailSubmit)
  }
}

// Handle signup with email form submit
function handleEmailSubmit(event: Event): void {
  event.preventDefault()

  const email = assertNotNull(
    document.querySelector('.get-free-summary__input') as HTMLInputElement,
  )
  const emailValue = encodeURIComponent(email.value)
  setLocation(`/app/signup?email=${emailValue}?cta=email_signup`, () => {})
}

function trackCTAClicks(): void {
  const storeLinks = document.querySelectorAll(
    '.apps__link',
  ) as NodeListOf<HTMLElement>
  storeLinks.forEach((link) => {
    link.addEventListener('click', () =>
      Mixpanel.trackHomeCTAClick('store_link', link.id),
    )
  })

  const reviewTabs = document.querySelectorAll(
    '.blockquote-people-slider__button',
  ) as NodeListOf<HTMLElement>
  reviewTabs.forEach((tab) => {
    tab.addEventListener('click', () =>
      Mixpanel.trackHomeCTAClick('review', tab.id),
    )
  })

  const pilotInterestedLink = document.querySelector(
    '.pilot-hero__button',
  ) as HTMLElement
  if (pilotInterestedLink) {
    pilotInterestedLink.addEventListener('click', () =>
      Mixpanel.trackPilotCTAClick('top_interested'),
    )
  }

  const pilotInterestedFormButton = document.querySelector(
    '#ic-button-yes',
  ) as HTMLElement
  if (pilotInterestedFormButton) {
    pilotInterestedFormButton.addEventListener('click', () =>
      Mixpanel.trackPilotCTAClick('interest_form_submit', 'yes'),
    )
  }

  const pilotNotInterestedFormButton = document.querySelector(
    '#ic-button-no',
  ) as HTMLElement
  if (pilotNotInterestedFormButton) {
    pilotNotInterestedFormButton.addEventListener('click', () =>
      Mixpanel.trackPilotCTAClick('interest_form_submit', 'no'),
    )
  }
}
